import { render } from "./ssc.vue?vue&type=template&id=355a0e6e&scoped=true"
import script from "./ssc.vue?vue&type=script&lang=js"
export * from "./ssc.vue?vue&type=script&lang=js"

import "./ssc.vue?vue&type=style&index=0&id=355a0e6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355a0e6e"]])

export default __exports__